// extracted by mini-css-extract-plugin
module.exports = {"notify_container":"Notification_notify_container__1rw8s","notify_title":"Notification_notify_title__34Q6l","notification_card":"Notification_notification_card__3uV6W"};